module.exports = __webpack_public_path__ + "img/Red-bull.6cf1f31e.svg";